var React = require('react');

function CircleStrokeGrey (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval Copy 16@1.5x"),React.createElement("g",{"id":"Desktop-(1440px)","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("ellipse",{"id":"Oval-Copy-16","stroke":"#F0F3F9","strokeWidth":"80","cx":"383","cy":"384","rx":"343","ry":"344"}))]);
}

CircleStrokeGrey.defaultProps = {"width":"766px","height":"768px","viewBox":"0 0 766 768","version":"1.1"};

module.exports = CircleStrokeGrey;

CircleStrokeGrey.default = CircleStrokeGrey;
